import { z } from 'zod';

export const APP_NAME = 'Regia';
export const TIME_ZONE = 'Europe/Rome';

export type Severity = 'info' | 'warn' | 'alert';

export interface ApiErrorBody {
  error: { code: string; message: string; fields?: Record<string, string> };
}

export interface Paged<T> {
  items: T[];
  nextCursor: string | null;
}

/** Colori delle cartelline (spec 6.1). `fg` è il colore del testo sopra il colore. */
export const FOLDER_COLORS = {
  rosso: { label: 'Rosso', bg: '#D7263D', fg: '#FFFFFF' },
  arancio: { label: 'Arancio', bg: '#EE6C2B', fg: '#FFFFFF' },
  ocra: { label: 'Ocra', bg: '#E3A008', fg: '#18244A' },
  verde: { label: 'Verde', bg: '#2E9C5A', fg: '#FFFFFF' },
  petrolio: { label: 'Petrolio', bg: '#0E7C7B', fg: '#FFFFFF' },
  cobalto: { label: 'Cobalto', bg: '#2E5BFF', fg: '#FFFFFF' },
  indaco: { label: 'Indaco', bg: '#4B3FD1', fg: '#FFFFFF' },
  viola: { label: 'Viola', bg: '#8E44C9', fg: '#FFFFFF' },
  rosa: { label: 'Rosa', bg: '#E0559A', fg: '#FFFFFF' },
  grafite: { label: 'Grafite', bg: '#4A5568', fg: '#FFFFFF' },
} as const;

export type FolderColor = keyof typeof FOLDER_COLORS;
export const FOLDER_COLOR_KEYS = Object.keys(FOLDER_COLORS) as [FolderColor, ...FolderColor[]];
export const folderColorSchema = z.enum(FOLDER_COLOR_KEYS);

export const PLATFORMS = [
  'facebook',
  'instagram',
  'google_business',
  'website',
  'tiktok',
  'youtube',
  'linkedin',
] as const;
export type Platform = (typeof PLATFORMS)[number];
export const platformSchema = z.enum(PLATFORMS);

export const PLATFORM_LABELS: Record<Platform, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  google_business: 'Scheda Google',
  website: 'Sito',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  linkedin: 'LinkedIn',
};

/** Trasforma un nome in uno slug da URL: "Villa Roveglia!" diventa "villa-roveglia". */
export function slugify(input: string): string {
  const base = input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' e ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
    .replace(/-+$/g, '');
  return base || 'scheda';
}

export const otpCodeSchema = z
  .string()
  .trim()
  .regex(/^\d{6}$/, 'Il codice ha 6 cifre');

export const cursorQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
